import { Link } from "react-router-dom";

const FRIEND_LINKS = [
  { label: "影视观察", href: "#" },
  { label: "文艺放映室", href: "#" },
  { label: "美剧速递", href: "#" },
  { label: "纪录片之家", href: "#" },
  { label: "编剧手记", href: "#" },
];

export default function Footer() {
  return (
    <footer className="mt-16 bg-primary-950 text-background-100">
      <div className="w-full px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 rounded-md bg-accent-500 text-background-50 flex items-center justify-center font-label text-lg font-semibold">
                黑
              </span>
              <span className="font-heading font-black text-xl text-background-50">
                黑皮辣妹
              </span>
            </div>
            <p className="text-sm leading-relaxed text-background-200 max-w-md">
              黑皮辣妹影视资讯与剧情介绍频道，专注影视新闻、剧情解析与作品资料，
              为影迷提供及时、深入、好看的影视内容。从热门新片到冷门佳作，
              我们陪你一起追剧、聊片、看懂故事。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" aria-label="微博" className="w-9 h-9 rounded-md bg-primary-900 flex items-center justify-center text-background-100 hover:bg-accent-500 hover:text-background-50 transition-colors">
                <i className="ri-weibo-fill" />
              </a>
              <a href="#" aria-label="微信" className="w-9 h-9 rounded-md bg-primary-900 flex items-center justify-center text-background-100 hover:bg-accent-500 hover:text-background-50 transition-colors">
                <i className="ri-wechat-fill" />
              </a>
              <a href="#" aria-label="豆瓣" className="w-9 h-9 rounded-md bg-primary-900 flex items-center justify-center text-background-100 hover:bg-accent-500 hover:text-background-50 transition-colors">
                <i className="ri-douban-fill" />
              </a>
              <a href="#" aria-label="哔哩哔哩" className="w-9 h-9 rounded-md bg-primary-900 flex items-center justify-center text-background-100 hover:bg-accent-500 hover:text-background-50 transition-colors">
                <i className="ri-bilibili-fill" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-bold text-background-50 mb-4">内容导航</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/category/news" className="text-background-200 hover:text-accent-400 transition-colors">影视资讯</Link></li>
              <li><Link to="/category/plot" className="text-background-200 hover:text-accent-400 transition-colors">剧情解析</Link></li>
              <li><Link to="/category/works" className="text-background-200 hover:text-accent-400 transition-colors">作品库</Link></li>
              <li><Link to="/about" className="text-background-200 hover:text-accent-400 transition-colors">关于我们</Link></li>
              <li><Link to="/contact" className="text-background-200 hover:text-accent-400 transition-colors">联系我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-background-50 mb-4">友情链接</h4>
            <ul className="space-y-2.5 text-sm">
              {FRIEND_LINKS.map((link) => (
                <li key={link.label}>
                  <a href={link.href} className="text-background-200 hover:text-accent-400 transition-colors">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-900 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-300">
          <p>© 2026 黑皮辣妹影视资讯与剧情介绍频道 · 保留所有权利</p>
          <p>本站内容为演示示范数据，仅用于产品展示。</p>
        </div>
      </div>
    </footer>
  );
}